import * as React from 'react';
import { CustomTooltip } from '../CustomTooltip';
import { useClickController } from '../../internal';

/**
 * Компонент тултипа для онбординга
 *
 * @export
 * @param {IOnboardingTooltipProps} props
 * @returns
 */
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function OnboardingTooltip(props) {
  const {
    theme = 'blue',
    children,
    content,
    flip = true,
    header,
    placement,
    portal,
    portalElement
  } = props;
  const {
    childrenProps,
    childrenRef,
    open,
    handleClose
  } = useClickController(props);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/React.cloneElement(children, childrenProps), /*#__PURE__*/_jsx(CustomTooltip, {
      header: header,
      content: content,
      open: open,
      anchorRef: childrenRef,
      placement: placement,
      theme: theme,
      portal: portal,
      portalElement: portalElement,
      arrow: true,
      flip: flip,
      preventOverflow: true,
      closeButton: true,
      minHeight: 56,
      maxWidth: 320,
      onClose: handleClose
    })]
  });
}